// extracted by mini-css-extract-plugin
export default {"container":"LayoutNew_container__KsZYs","sub_container":"LayoutNew_sub_container__3p0i1"};